<template>
  <div class="flex flex-wrap mb-2" :style="guideStep == 111 ? { zIndex: 100, position: 'relative' } : null">
    <div class="w-3/4 flex-1 bg-white rounded-xl space-y-6 p-2">
      <div class="v01_outer">
        <div class="v01_inner">
          <div class="space-y-2 rounded-xl border p-2 cursor-pointer" :style="itemStage(customRulesDataList.editIndex, index)" v-for="(item, index) in customRulesDataList.subCampaignsContent" :key="index" @click="changeEdit(index)">
            <span v-if="item" class="px-2">{{ item.method ? methodName(item.method) : '' }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="hidden lg:block w-1/4 rounded-xl space-y-2 px-4 event-tips-sidebar"></div>
    <div v-if="guideStep == 111" style="width: 100%; height: 100vh; position: absolute; top: 0; background-color: rgba(0,0,0,0);"></div>
  </div>
</template>
<script>
import lightImg from "@/assets/light.png";

export default {
  name: "CampaignName",
  components: {},
  props: {
    // <!-- 新手教學 -->
    guideStep: {
      type: Number,
      default: -1
    },
    teachingId: {
      type: Number,
    },
    // <!-- 新手教學 -->
    editPage: {
      type: Boolean
    },
    viewDatalist: {
      type: String
    },
    customRulesDataList: {
      type: Object
    },
    lang: {
      type: Object
    },
  },
  data() {
    return {
      lightImg: lightImg,
      campaignName: ''
    };
  },
  watch:{
    'lang':function(v){
      console.log('CampaignName watch this.lang');
      console.log(this.lang);
    },
    'viewDatalist':function(v){
      console.log('viewDatalist：'+v);
      this.campaignName = v
    },
    campaignName (value){
      console.log('value：'+value);
      // this.viewDatalist = value;
      this.$emit('childCampaignName', value);
      // console.log('viewDatalistData：'+this.viewDatalist);
    }
  },
  methods: {
    openTeaching(){
      this.$emit('childOpenTeaching', 111);
    },
    methodName(value){
      switch(value){
        case 'META_TEST':
          return '測試素材（Facebook）';
          break;
        case 'META_KW':
          return '精準興趣（Facebook）';
          break;
        case 'META_LA':
          return '類似受眾（Facebook）';
          break;
        case 'META_RT':
          return '再行銷（Facebook）';
          break;
        case 'META_ASC':
          return 'ASC（Facebook）';
          break;
        case 'TIKTOK_KW':
          return '精準興趣（Tiktok）';
          break;
        case 'TIKTOK_RT':
          return '再行銷（Tiktok）';
          break;
      }
    },
    itemStage(action, index){
      //console.log('itemStage');
      //console.log(action +':'+ index);
      if(action == index){
        return {backgroundColor:'#1D619F', color:'#fff'};
      } else {
        return {backgroundColor:'#F2F2F2', color:'#8C8C8C'};
      }
    },
    changeEdit(index){
      var todayForm = new Date();
      var yearForm = todayForm.getFullYear();
      var dateForm = String(todayForm.getDate()).padStart(2, '0');
      var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
      var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

      todayForm = yearForm + monthForm + dateForm + timeForm;

      //console.log('b stageblock customRulesDataList');
      //console.log(this.customRulesDataList);

      this.$emit('childChangeEdit', index+'_'+todayForm);

      //console.log('a stageblock customRulesDataList');
      //console.log(this.customRulesDataList);
    }
  },
  computed: {
    editPageType: {
      get: function () {
        return this.editPage
      },
      set: function (value) {
        this.$emit('update:editPageType', value)
      },
    },
    customRulesDataListData: {
      get: function () {
        return this.customRulesDataList
      },
      set: function (value) {
        this.$emit('update:customRulesDataListData', value)
      },
    },
  }
};
</script>
<style lang="scss" scope>
.remarketing {
  .p-multiselect-label-container {
    display: none;
  }
}
</style>
<style>
  .outer {
    max-width: 950px; /* 設定外部容器的最大寬度 */
    overflow-x: auto; /* 溢出時產生橫向滾動條 */
  }
  .inner {
    display: flex; /* 使用 flexbox 佈局 */
  }
  .inner div {
    min-width: 120px; /* 每個內部 div 的最小寬度 */
    height: 55px; /* 每個內部 div 的高度 */
    margin: 5px 15px; /* 每個內部 div 之間的間距 */
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .inner div:not(:last-child)::after {
    content: '';
    position: absolute;
    right: -20px; /* 調整箭頭的位置 */
    top: 50%;
    transform: translateY(-50%);
    border: solid black;
    border-width: 0 3px 3px 0;
    display: inline-block;
    padding: 5px;
    transform: rotate(-45deg);
    -webkit-transform: rotate(-45deg);
  }
  .inner div:not(:last-child)::before {
    content: '';
    position: absolute;
    right: -20px; /* 調整箭頭的位置 */
    top: 50%;
    transform: translateY(-50%) rotate(45deg);
    display: block;
    width: 10px;
    height: 10px;
    border-top: 2px solid black;
    border-right: 2px solid black;
  }

  .v01_outer {
    max-width: 950px; /* 設定外部容器的最大寬度 */
    overflow-x: auto; /* 溢出時產生橫向滾動條 */
    padding: 5px;
  }
  .v01_inner {
    display: flex; /* 使用 flexbox 佈局 */
    align-items: center; /* 垂直居中對齊 */
  }
  .v01_inner div {
    min-width: 210px; /* 每個內部 div 的最小寬度 */
    height: 55px; /* 每個內部 div 的高度 */
    margin: 5px 15px; /* 每個內部 div 之間的間距 */
    background-color: #f0f0f0; /* 可選：內部 div 的背景色 */
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
  }
  .v01_inner div:not(:last-child)::after {
    content: '';
    position: absolute;
    right: -20px; /* 調整箭頭的位置 */
    top: 50%;
    transform: translateY(-50%);
    display: block;
    width: 15px; /* 橫線的長度 */
    height: 2px; /* 橫線的厚度 */
    background-color: black; /* 橫線的顏色 */
  }
  .v01_inner div:not(:last-child)::before {
    content: '';
    position: absolute;
    right: -20px; /* 調整箭頭的位置 */
    top: 50%;
    transform: translateY(-50%) rotate(45deg);
    display: block;
    width: 10px;
    height: 10px;
    border-top: 2px solid black;
    border-right: 2px solid black;
  }

  /* 自定義滾動條樣式 */
  .v01_outer::-webkit-scrollbar {
    width: 10px;
    height: 10px;
  }

  .v01_outer::-webkit-scrollbar-track {
    background: #f1f1f1;
  }

  .v01_outer::-webkit-scrollbar-thumb {
    background: #D9D9D9;
    border-radius: 6px;
  }

  .v01_outer::-webkit-scrollbar-thumb:hover {
    background: #D9D9D9;
  }
</style>